module.exports = __webpack_public_path__ + "img/nao-encontrado-mobile.c3d1b620.png";